import {hackFixDSTExcelDates} from '../../core-utilities/redux-observable-list-exports/utils';
import {ReduxListExports} from '../../core-utilities/redux-observable-list-exports';
import {serializeFilterOptions} from '../../_libs/redux-observable-list';
import {BASE_REDUX_LIST_OPTIONS} from '../../config/redux-list';
import {TimerExport} from '../components/TimerExport';
import {getTimerExport} from '../reducers/state';
import {TIMER_ACTIVITIES_COLLECTION} from '../domain/config';
import {TIMER_EXPORT_PREFIX} from './state';
import {logger} from './logger';

const dateHeaders = [
  'Start Time',
  'End Time',
];

export function getLastMidnight() {
  const midnight = new Date();
  midnight.setHours(0, 0, 0, 0);
  return new Date(midnight.getTime() - 1);
}

export function getDefaultFilterData() {
  return {
    filter: '',
    filterOptions: {
      dateRange: {
        useAfter: true,
        afterDate: getLastMidnight(),
        useBefore: false,
        // beforeDate: new Date(), late injection
      },
      // possibly some other stuff
      // we may add geo-relevant filtering options, like within range, outside of range, etc.
      //  - Reports may apply filtering on the server
      //  - for lists, like on map, we could just highlight stuff differently rather than actually filtering it out.
      //    - Actually filtering from list results would require caching target geo and delta, which would cause headaches for keeping data in sync.
      // may want to allow pulling a report for a specified user
    },
  };
}

// Used for server request exclusion. This differs from the default presented to the user.
export const defaultFilterOptions = {
  dateRange: {
    useAfter: false,
    useBefore: false,
  },
};

/** @type {ReduxListExports} */
export const reduxListExports = new ReduxListExports({
  ...BASE_REDUX_LIST_OPTIONS,
  prefix: TIMER_EXPORT_PREFIX,
  hasParentId: false,
  reportPath: `${TIMER_ACTIVITIES_COLLECTION}/_report`,
  useFilterOptions: true,
  serializeFilterOptions,
  defaultFilterOptions,
  modalComponent: TimerExport,
  getFileName: () => 'time data',
  buildRequest,
  modifyResponse: hackFixDSTExcelDates(dateHeaders),
  getReportState: getTimerExport,
  exportConfig: {
    useListStateFilter: false,
    getDefaultFilterData: () => ({
      filterOptions: getDefaultFilterData().filterOptions,
    }),
  },
  logger,
});

const originalReducer = reduxListExports.reducers.reducer;

reduxListExports.reducers.reducer = function (state = reduxListExports.reducers.initialState, action) {
  switch (action.type) {
    case reduxListExports.actions.showModal.TYPE:
      return {
        ...originalReducer(state, action),
        ...getDefaultFilterData(),
      };

    default:
      return originalReducer(state, action);
  }
};

function buildRequest(exportState) {
  return {
    filterData: {
      filterOptions: {
        ...exportState.filterOptions,
        ...exportState.targetFilter,
      },
    },
  };
}



// WEBPACK FOOTER //
// ./src/js/timers/redux/timerExports.js